import React from 'react';
import { useTranslation } from 'react-i18next';
import { defaultDateFormat } from '../../Dates';
import { connect } from 'react-redux';
import { momentParse } from 'react-lib/dist/dates-es';

type Props = {
  userLabel: string;
  userValue: string;
  dateLabel: string;
  dateValue: any;
  showPersonalData?: boolean;
};

const TraceabilityDetail = ({
  userLabel,
  userValue,
  dateLabel,
  dateValue,
  showPersonalData,
}: Props) => {
  const { t } = useTranslation();
  dateValue = momentParse(dateValue); 

  return userValue && dateValue ? (
    <>
      <label>
        <b>{t(userLabel)}</b> {showPersonalData ? userValue : userValue.replace(/[a-z]/g, 'x')}
      </label>
      <label>
        <b>{t(dateLabel)}</b> {dateValue.format(defaultDateFormat)}
      </label>
      <br />
    </>
  ) : (
    <></>
  );
};

interface TraceabilityDetailsProps {
  traceableEntity?: any;
  showPersonalData?: boolean;
}

class TraceabilityDetails extends React.Component<TraceabilityDetailsProps> {
  getTraceabilityDetails() {
    const { traceableEntity, showPersonalData } = this.props;
    let traceabilityDetails = [];

    if (traceableEntity.histCreateUser)
      traceabilityDetails.push(
        <TraceabilityDetail
          key="traceabilityDetailsHistoryCreateDetails"
          userLabel="traceability.details.history.create.user"
          userValue={traceableEntity.histCreateUser.name}
          dateLabel="traceability.details.history.create.date"
          dateValue={traceableEntity.histCreateDte}
          showPersonalData={showPersonalData}
        />
      );

    if (traceableEntity.createUser)
      traceabilityDetails.push(
        <TraceabilityDetail
          key="traceabilityDetailsCreateDetails"
          userLabel="traceability.details.create.user"
          userValue={traceableEntity.createUser.name}
          dateLabel="traceability.details.create.date"
          dateValue={traceableEntity.createDte}
          showPersonalData={showPersonalData}
        />
      );

    if (traceableEntity.updateUser)
      traceabilityDetails.push(
        <TraceabilityDetail
          key="traceabilityDetailsUpdateDetails"
          userLabel="traceability.details.update.user"
          userValue={traceableEntity.updateUser.name}
          dateLabel="traceability.details.update.date"
          dateValue={traceableEntity.updateDte}
          showPersonalData={showPersonalData}
        />
      );

    if (traceableEntity.delUser)
      traceabilityDetails.push(
        <TraceabilityDetail
          key="traceabilityDetailsDeleteDetails"
          userLabel="traceability.details.delete.user"
          userValue={traceableEntity.delUser.name}
          dateLabel="traceability.details.delete.date"
          dateValue={traceableEntity.delDte}
          showPersonalData={showPersonalData}
        />
      );

    if (traceableEntity.checkUser)
      traceabilityDetails.push(
        <TraceabilityDetail
          key="traceabilityDetailsCheckDetails"
          userLabel="traceability.details.check.user"
          userValue={traceableEntity.checkUser.name}
          dateLabel="traceability.details.check.date"
          dateValue={traceableEntity.checkDte}
          showPersonalData={showPersonalData}
        />
      );

    return traceabilityDetails;
  }

  render() {
    return <div className="detailsFormOptions">{this.getTraceabilityDetails()}</div>;
  }
}

const mapStateToProps = (state: any) => ({
  showPersonalData: state.dataPrivacy.showPersonalData,
});

export default connect(mapStateToProps, null)(TraceabilityDetails);
